import { Component, ReactNode } from 'react';

import { memoize } from 'lodash-es';

import { CommitGraphElement } from 'src/utils/commit-graph-builder';

import { GraphProps } from './graph';

const getMaxColumns = (graph: CommitGraphElement[]) => {
  return (
    graph.length && Math.max(1, ...graph.map(node => node.segments.length))
  );
};

type RenderProps = GraphProps & {
  maxColumns: number;
};

type CommitGraphProps = {
  columnWidth: number;
  commitGraphElements: CommitGraphElement[];
  focusedCommitHash: string;
  isCollapsed: boolean;
  isLoading: boolean;
  onNodeClick: (id: string) => void;
  offsetX: number;
  offsetY: number;
  sliceHeight: number;
  children: (options: RenderProps) => ReactNode;
};

export default class CommitGraph extends Component<CommitGraphProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    focusedCommitHash: null,
    isCollapsed: false,
    isLoading: false,
    onNodeClick: () => {},
  };

  // @ts-ignore TODO: fix noImplicitAny error here
  shouldComponentUpdate({ isCollapsed, isLoading }) {
    if (isLoading) {
      return false;
    }
    // Don't update if the graph is collapsed, unless it is transitioning to collapsed.
    return this.props.isCollapsed !== isCollapsed || !isCollapsed;
  }

  chunkSize = 0;
  getMaxColumns = memoize(getMaxColumns);

  render() {
    const {
      columnWidth,
      commitGraphElements,
      isCollapsed,
      focusedCommitHash: focusedHash,
      offsetX,
      offsetY,
      onNodeClick,
      sliceHeight,
    } = this.props;

    if (!commitGraphElements.length) {
      return null;
    }

    if (!this.chunkSize) {
      // Set the chunk size based on the first page of commits
      this.chunkSize = commitGraphElements.length;
    }

    const maxColumns = this.getMaxColumns(commitGraphElements);
    let width = 0;
    let height = 0;

    if (!isCollapsed) {
      width = offsetX + maxColumns * columnWidth;
      height = (commitGraphElements.length + 1) * sliceHeight;
    }

    return this.props.children({
      chunkSize: this.chunkSize,
      colWidth: columnWidth,
      focusedHash,
      graph: commitGraphElements,
      offsetX,
      offsetY,
      onNodeClick,
      sliceHeight,
      width,
      height,
      maxColumns,
      hasPadding: false,
    });
  }
}
